/**
 * TradingAgentShell — wraps Trading Agent routes with the terminal chrome
 * (grid background). Matches tmp/platform-mockups/trading-agent.html. The
 * background is only rendered when the appSlug URL param is trading-agent;
 * other apps that nest these same routes (e.g. /apps/smart-news/dashboard)
 * keep their own atmosphere.
 */
import { Outlet, useParams } from 'react-router-dom';

import '@shared/trading-agent/trading-agent.css';

export default function TradingAgentShell() {
  const { appSlug } = useParams<{ appSlug: string }>();
  const showTerminalChrome = appSlug === 'trading-agent';

  return (
    <div className="relative">
      {showTerminalChrome && <div className="ta-grid-bg" aria-hidden="true" />}
      <Outlet />
    </div>
  );
}
